import { render, staticRenderFns } from "./packageTable.vue?vue&type=template&id=5349b62b&scoped=true&"
import script from "./packageTable.vue?vue&type=script&lang=js&"
export * from "./packageTable.vue?vue&type=script&lang=js&"
import style0 from "./packageTable.vue?vue&type=style&index=0&id=5349b62b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349b62b",
  null
  
)

component.options.__file = "packageTable.vue"
export default component.exports